import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import { Suspense, lazy } from 'react';

// Lazy Load Pages
const Home = lazy(() => import('./pages/Home'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const About = lazy(() => import('./pages/About'));
const Services = lazy(() => import('./pages/Services'));
const Contact = lazy(() => import('./pages/Contact'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const DashboardLayout = lazy(() => import('./pages/DashboardLayout'));
const DashboardHome = lazy(() => import('./pages/DashboardHome'));
const DashboardServices = lazy(() => import('./pages/DashboardServices'));
const DashboardPortfolio = lazy(() => import('./pages/DashboardPortfolio'));
const DashboardMessages = lazy(() => import('./pages/DashboardMessages'));
const DashboardUsers = lazy(() => import('./pages/DashboardUsers'));
const UserLogin = lazy(() => import('./pages/UserLogin'));
const UserSignup = lazy(() => import('./pages/UserSignup'));
const UserDashboard = lazy(() => import('./pages/UserDashboard'));
const UserProtectedRoute = lazy(() => import('./components/UserProtectedRoute'));

// Loading Component
const Loading = () => (
  <div className="flex items-center justify-center min-h-screen bg-slate-50">
    <div className="w-12 h-12 border-4 border-rose-200 border-t-rose-600 rounded-full animate-spin"></div>
  </div>
);

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<DashboardHome />} />
                <Route path="dashboard" element={<DashboardHome />} />
                <Route path="services" element={<DashboardServices />} />
                <Route path="portfolio" element={<DashboardPortfolio />} />
                <Route path="messages" element={<DashboardMessages />} />
                <Route path="users" element={<DashboardUsers />} />
              </Route>
              {/* User Authentication Routes */}
              <Route path="/login" element={<UserLogin />} />
              <Route path="/signup" element={<UserSignup />} />
              <Route
                path="/user/dashboard"
                element={
                  <UserProtectedRoute>
                    <>
                      <Navbar />
                      <UserDashboard />
                      <Footer />
                    </>
                  </UserProtectedRoute>
                }
              />
              <Route
                path="/"
                element={
                  <>
                    <Navbar />
                    <Outlet />
                    <Footer />
                  </>
                }
              >
                <Route index element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="services" element={<Services />} />
                <Route path="portfolio" element={<Portfolio />} />
                <Route path="contact" element={<Contact />} />
              </Route>
            </Routes>
          </Suspense>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;

